<template>
  <b-modal
    v-bind="$attrs"
    no-close-on-backdrop
    v-on="mountEventListeners">
    <slot />
    <template #modal-header>
      <slot name="modal-header" />
    </template>
    <template #modal-title>
      <slot name="modal-title" />
    </template>
    <template #modal-header-close>
      <slot name="modal-header-close" />
    </template>
    <template #modal-footer>
      <slot name="modal-footer" />
    </template>
    <template #modal-ok>
      <slot name="modal-ok" />
    </template>
    <template #modal-cancel>
      <slot name="modal-cancel" />
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'CoozzyModal',
  inheritAttrs: false,
  computed: {
    mountEventListeners() {
      return this.$listeners
    }
  }
}
</script>

<style type="scss" scoped>
</style>
